import React from "react";
import Logo from './Logo';
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar, Typography, Button } from "@material-ui/core/";
import { NavLink, useRouteMatch, Redirect } from "react-router-dom";
import { useStore } from "../store/StoreProvider";
import { observer } from "mobx-react";

const useStyles = makeStyles(() => ({
	bar: {
    backgroundColor: "#1C1A19",
    color: '#fff'
	},
	title: {
		flexGrow: 1
  },
  toolbar: {
    paddingTop: '4px',
    paddingBottom: '4px'
  }
}));

const Header = () => {
	const classes = useStyles();
  const { logout, isLoggedIn } = useStore();
  const { url } = useRouteMatch();

  if (!isLoggedIn) {
    return <Redirect to='/login' />
  }

	return (
		<AppBar position="static" className={classes.bar}>
			<Toolbar className={classes.toolbar}>
				<div className={classes.title}>
					<Logo />
				</div>
				<Button component={NavLink} to={`${url}/order`} color="inherit" activeStyle={{ color: '#FDBF5A' }}>
					Карта
				</Button>
				<Button component={NavLink} to={`${url}/profile`} color="inherit" activeStyle={{ color: '#FDBF5A' }}>
					Профиль
				</Button>
				<Button onClick={logout} color="inherit">
					Выйти
				</Button>
			</Toolbar>
		</AppBar>
	);
};

export default observer(Header);
